<template>
  <v-app>
    <template v-if="!isLoading && getAgent">
      <DrawerApp :user="getAgent" :drawer.sync="drawer" class="hidden-sm-and-down" />
      <Navbar
        :user="getAgent"
        :clipped="clipped"
        :title="title"
        :drawer.sync="drawer"
        class="hidden-lg-and-up hidden-md-and-up"
      />
      <!-- <StepsBanner v-if="showStepsBanner && !getAgent.helper_complete && getAgent.role === $roles.ENTREPRENEUR" /> -->
      <NotificationsBanner v-if="getAgentNotifications && getAgentNotifications.length" />
      <v-main class="sm-max-p-0" :class="showStepsBanner ? '' : 'sm-and-down-mt-56'">
        <v-container class="sm-max-p-0 mb-15 md-mb-0">
          <v-fade-transition mode="out-in">
            <slot />
          </v-fade-transition>
        </v-container>
      </v-main>
      <!--
      <WelcomeModal v-if="showWelcomeModal && !getAgent.helper_complete && getAgent.role === $roles.ENTREPRENEUR" />
      -->
      <TutorialModal v-if="!getAgent.helper_complete && getAgent.role === $roles.ENTREPRENEUR" />
      <FrequentQuestionsDrawer />
      <TicketDetailDrawer v-if="getSelectedTicketId" />
      <BottomNavigationApp class="hidden-lg-and-up hidden-md-and-up" />
      <v-snackbar v-if="notification" v-model="showNotification" bottom right multi-line :timeout="6000" elevation="20">
        {{ notification.text }}
        <v-spacer />
        <v-btn v-if="notification.link" primary icon :to="notification.link" target="_blank">
          <v-icon dark small> fas fa-external-link-alt </v-icon>
        </v-btn>
        <v-btn primary icon class="ml-0" @click="showNotification = false">
          <v-icon dark small> fas fa-times </v-icon>
        </v-btn>
      </v-snackbar>
    </template>
    <template v-else>
      <Loading />
    </template>
  </v-app>
</template>
<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
// import { wegrou } from "Config/config";
import { messaging } from "@/config/firebase";
import { notificationTypes } from "@/helpers/get_constants";
import formatNotification from "@/helpers/format_notification";
import Loading from "@/components/inc/Loading";
import Navbar from "@/components/inc/Navbar";
import DrawerApp from "@/components/inc/DrawerApp";
import BottomNavigationApp from "@/components/inc/BottomNavigationApp";
// import StepsBanner from "@/components/help/StepsBanner";
import NotificationsBanner from "@/components/help/NotificationsBanner";
// import WelcomeModal from "@/components/help/WelcomeModal";
import TutorialModal from "@/components/help/TutorialModal";
import FrequentQuestionsDrawer from "@/components/help/FrequentQuestionsDrawer";
import TicketDetailDrawer from "@/views/tickets/TicketDetailDrawer";
import EventBus from "@/index";
import getCurrentUser from "@/helpers/get_current_user";

export default {
  name: "Default",
  components: {
    Navbar,
    DrawerApp,
    // StepsBanner,
    NotificationsBanner,
    // WelcomeModal,
    TutorialModal,
    FrequentQuestionsDrawer,
    BottomNavigationApp,
    TicketDetailDrawer,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      clipped: false,
      title: "",
      drawer: true,
      showNotification: false,
      notification: null,
    };
  },
  computed: {
    ...mapGetters([
      "getAgent",
      "getBusiness",
      "getSubscription",
      "getSelectedTicketId",
      "showWelcomeModal",
      "showStepsBanner",
      "getAgentNotifications",
    ]),
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.title = this.getTitle();
      }
    },
    async getAgent(value, oldValue) {
      if (value && !oldValue) await this.init();
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) this.$vuetify.theme.dark = theme === "true";
  },
  async created() {
    this.title = this.getTitle();

    EventBus.$on(
      "setNotification",
      function (payload) {
        this.notification = formatNotification({ route: this.$route, ...payload });
        this.showNotification = true;
      }.bind(this),
    );

    if (this.getAgent) await this.init();
  },
  methods: {
    ...mapActions([
      "getBusinessConfig",
      "getSubscriptionConfig",
      "handleDeviceNotifications",
      "getAllNewNotifications",
    ]),
    async init() {
      try {
        this.isLoading = true;

        let agent = await getCurrentUser();
        if (!agent || agent.role === "anonymous") return this.$router.replace({ name: "login" });

        if (
          [
            this.$roles.SUPER_ADMIN,
            this.$roles.ENTREPRENEUR,
            this.$roles.SUPERVISOR,
            this.$roles.ADVISOR_LEVEL1,
            this.$roles.ADVISOR_LEVEL2,
          ].includes(this.getAgent.role) &&
          !this.getBusiness
        ) {
          await this.getBusinessConfig();

          if (
            [this.$roles.ENTREPRENEUR, this.$roles.ADVISOR_LEVEL1, this.$roles.ADVISOR_LEVEL2].includes(
              this.getAgent.role,
            ) &&
            !this.getSubscription
          )
            await this.getSubscriptionConfig();

          if (this.getBusiness?.currency) Vue.prototype.$currency = this.getBusiness.currency;
        }
        /*
        if (wegrou && !this.getAgent.helper_complete) {
          if (this.getAgent.helper_current_step) {
            this.setShowStepsBanner(true);
          } else {
            this.setShowWelcomeModal(true);
          }
        }
        */
        if (process.env.NODE_ENV === "production" && messaging) await this.verifyAllowNotifications();

        await this.getAllNewNotifications();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    getTitle() {
      return this.$route.meta.title || "";
    },
    async verifyAllowNotifications() {
      if ("Notification" in window) {
        const grant = await Notification.requestPermission();
        if (grant === "granted" && !localStorage.getItem("sync_notifications")) this.sendTokenToServer();
      }
    },
    async sendTokenToServer() {
      try {
        let token = await messaging.getToken();
        await this.handleDeviceNotifications({
          notification_types: [
            notificationTypes.NEW_TICKETS,
            notificationTypes.ASSIGN_TICKETS,
            notificationTypes.ASSIGN_ORDERS,
            notificationTypes.START_EVENTS,
          ],
          allow: true,
          token: token,
        });
        localStorage.setItem("sync_notifications", true);
      } catch (error) {
        console.error("notifications/sendTokenToServer: ", error);
      }
    },
  },
};
</script>
<style scoped>
@media (max-width: 959px) {
  .sm-and-down-mt-56 {
    margin-top: 56px;
  }
}
</style>
